import {
  Component,
  ViewEncapsulation,
  OnInit,
  Inject, Attribute, ViewChild
} from '@angular/core';

import {
  FormBuilder,
  Validators,
  FormGroup,
  FormControl, AbstractControl, Validator, ValidatorFn
} from '@angular/forms';
import * as moment from 'moment-timezone';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {UserContext} from '../services/user-context';
import {FileInfo, FileRestrictions, SelectEvent, UploadComponent} from '@progress/kendo-angular-upload';
import {ApiService} from '../services/api';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {SchedulerEvent} from '@progress/kendo-angular-scheduler';

@Component({
  selector: 'app-availability-dialog',
  encapsulation: ViewEncapsulation.None,
  templateUrl: 'availability-dialog.template.html',
  styles: [
    "app-availability-dialog mat-dialog-container {padding:0;}",
    "app-availability-dialog mat-dialog-content.mat-dialog-content {background:#f7fafc;padding:24px;}",
    "app-availability-dialog mat-dialog-actions {display:flex;flex-direction: row;justify-content: space-between;}"
  ]
})

export class AvailabilityDialogComponent implements OnInit {

  public form: FormGroup;
  slot:SchedulerEvent;

  constructor(private formBuilder: FormBuilder,
              public dialogRef: MatDialogRef<AvailabilityDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {

    this.slot = data;
    console.log("Slot: " + JSON.stringify(this.slot,null,4));
  }

  public ngOnInit(): void {
    this.buildForm();
  }

  public buildForm() {
    this.form = this.formBuilder.group({
      start: new FormControl( this.slot.start, [
        Validators.required
      ]),
      end: new FormControl( this.slot.end, [
        Validators.required
      ]),
      type: new FormControl((this.slot.dataItem || {}).type === "telehealth", [
      ]),
      recurring: new FormControl(this.slot.recurrenceRule === "FREQ=WEEKLY", [
      ])
    });
  }

  public save() {
    this.slot.start = this.form.value.start;
    this.slot.end = this.form.value.end;
    this.slot.dataItem = this.slot.dataItem || {};
    this.slot.dataItem.type = this.form.value.type ? "telehealth" : "office";
    this.slot.recurrenceRule = this.form.value.recurring ? "FREQ=WEEKLY" : null;
    this.dialogRef.close(this.slot);
  }

  public cancel() {
    this.dialogRef.close();
  }
}
